import { apiClient, type CreatePackageCategoryDto } from '@/libs/api'

export type CreatePackageCategoryRequest = {
  tenantKey: string
  dto: CreatePackageCategoryDto
}

export const createPackageCategory = async ({
  tenantKey,
  dto
}: CreatePackageCategoryRequest) => {
  const { data, errors } = await apiClient
    ._tenant(tenantKey)
    .package_categories.$post({ body: dto })
  return { data, errors }
}
